var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.role === 1)?_c('span',[_vm._v(_vm._s(_vm.$t('standard')))]):(_vm.role === 10)?_c('span',[_vm._v(_vm._s(_vm.$t('manager')))]):(_vm.role === 9001)?_c('span',[_vm._v(_vm._s(_vm.$t('admin')))]):_c('span',[_vm._v(_vm._s(_vm.$t('unknown')))])}
var staticRenderFns = []

export { render, staticRenderFns }